import { rem } from "../../framework/theme/util/misc.js";
import toggle_button_module_default from "./toggle-button.module.js";
import { ActionIcon } from "@mantine/core";
import { useCallback, useMemo } from "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/toggle-button/ToggleButton.tsx
const ToggleButton = ({ Icon, CheckedIcon, checked, color = "primary", disabled = false, toggle, iconProps = {}, "data-testid": testId }) => {
	const hasAction = !!toggle;
	const DisplayIcon = useMemo(() => {
		if (checked) return CheckedIcon;
		return Icon;
	}, [
		checked,
		CheckedIcon,
		Icon
	]);
	const bgColor = disabled ? "var(--mantine-color-gray-0)" : `var(--mantine-color-${color}-0)`;
	const iconColor = `var(--mantine-color-${color}-7)`;
	const handleClick = useCallback((event) => {
		event.preventDefault();
		event.stopPropagation();
		toggle?.();
	}, [toggle]);
	return /* @__PURE__ */ jsx(ActionIcon, {
		type: "button",
		variant: "subtle",
		disabled,
		radius: "50%",
		size: rem(40),
		onClick: handleClick,
		__vars: {
			"--ai-bg": bgColor,
			"--ai-color": iconColor,
			"--ai-hover": hasAction ? `var(--mantine-color-${color}-0)` : bgColor,
			"--ai-hover-color": hasAction ? `var(--mantine-color-${color}-9)` : iconColor,
			"--toggle-button-cursor": hasAction ? "pointer" : "default"
		},
		classNames: toggle_button_module_default,
		"data-testid": testId,
		children: /* @__PURE__ */ jsx(DisplayIcon, {
			...iconProps,
			color
		})
	});
};

//#endregion
export { ToggleButton };